module.exports = __webpack_public_path__ + "static/home_section2_icon4-09c59dfa466793af45ae959dc74d90fc.png";